/* eslint-disable camelcase */
import { FC, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useQueryClient } from 'react-query';
import { coreService } from 'network-utils';
import { selectToken } from '@redux/slices/userSlice';
import { useGetVideoTutorial, getVideoTutorials } from '@queries/core/videoTutorials';
import { getRecentlyAdded } from '@queries/core/homepage';
import VideoTutorial from './videoTutorial';

const VideoTutorialContainer: FC<VideoTutorialContainerContainerProps> = (
    props: VideoTutorialContainerContainerProps
) => {
    const { setVideoTutorialUuid, videoTutorialUuid } = props;
    const queryClient = useQueryClient();
    const token = useSelector(selectToken);
    const { data, isLoading } = useGetVideoTutorial(token, videoTutorialUuid);

    const [videoTutorial, setVideoTutorial] = useState<coreService.VideoTutorialData>();
    const [videoStarted, setVideoStarted] = useState<boolean>(false);
    const [videoCompleted, setVideoCompleted] = useState<boolean>(false);

    useEffect(() => {
        if (!data) return;
        setVideoTutorial(data);
    }, [data]);

    useEffect(() => {
        videoStarted && coreService.videoTutorialApi.start(token, videoTutorialUuid);
    }, [videoStarted]);

    useEffect(() => {
        if (videoCompleted) {
            coreService.videoTutorialApi.complete(token, videoTutorialUuid);
            queryClient.removeQueries([getVideoTutorials, token]);
            queryClient.removeQueries([getRecentlyAdded, token]);
        }
    }, [videoCompleted]);

    const onClose = () => {
        setVideoTutorialUuid(undefined);
    };

    return (
        <VideoTutorial
            onStart={() => setVideoStarted(true)}
            onComplete={() => setVideoCompleted(true)}
            onClose={() => onClose()}
            isLoading={isLoading}
            videoUrl={videoTutorial?.videoUrl}
            uuid={videoTutorial?.uuid}
            name={videoTutorial?.displayName}
        />
    );
};

interface VideoTutorialContainerContainerProps {
    setVideoTutorialUuid: Function;
    videoTutorialUuid: string;
}

export default VideoTutorialContainer;
